<script setup lang="ts">
/**
 * 404 Not Found error page.
 *
 * The explanation is generated dynamically by `notFoundExplanation` using
 * `route.query.from` (the path the router could not match). No "Go To Login"
 * button — a 404 is a routing problem, not an auth failure, so re-logging in
 * would not help.
 */
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import ErrorView from '@/components/errors/ErrorView.vue'
import { ErrorCode } from '@/errors/codes'
import { ERROR_USER_MESSAGES, notFoundExplanation } from '@/errors/error_user_messages'

const route = useRoute()

const page = ERROR_USER_MESSAGES[ErrorCode.NotFound]
const title = page.title
const explanation = computed(() => notFoundExplanation(route.query.from))
const actions = page.actions ?? []
</script>

<template>
  <ErrorView
    :code="ErrorCode.NotFound"
    :title="title"
    :explanation="explanation"
    :actions="actions"
  />
</template>
